var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Registration } from "./Registration";
export class SearchResponse {
  constructor(_data) {
    /**
     */
    __publicField(this, "Registrations");
    /**
     */
    __publicField(this, "TotalCount");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SearchResponse
     */
    __publicField(this, "$type", "V1.Cesop.Registrations.Search.SearchResponse");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Registrations"] && _data["Registrations"].constructor === Array) {
        this.Registrations = [];
        for (let item of _data["Registrations"]) {
          const registrations_ = new Registration();
          this.Registrations.push(registrations_.init(item));
        }
      }
      this.TotalCount = _data["TotalCount"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Registrations && this.Registrations.constructor === Array) {
      _data["Registrations"] = [];
      for (let item of this.Registrations) {
        _data["Registrations"].push(item.toJSON());
      }
    }
    _data["TotalCount"] = this.TotalCount;
    return _data;
  }
}
